import { Timestamp } from '@angular/fire/firestore';
// import { OutputData } from '@editorjs/editorjs';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Lesson } from '../../models/lesson.school.model';

export const getLessons = createAction(
  '[School Lesson] Get Lessons',
  props<{
    groupId: string;
    // academicYear: number;
    gradeId?: string;
    createdById?: string;
    fromDate?: Timestamp;
    lastRecord?: Timestamp;
  }>(),
);

export const addLessonsToStore = createAction(
  '[School Lesson] Add Lessons to store',
  props<{ lessons: Lesson[] }>(),
);
export const addLessonToStore = createAction(
  '[School Lesson] Add Lesson to store',
  props<{ lesson: Lesson }>(),
);

export const getLessonsFailure = createAction(
  '[School Lesson] Get Lessons Failed',
  props<{ error: AppExceptionModel }>(),
);

export const getLesson = createAction(
  '[School Lesson] Get lesson',
  props<{ groupId: string; lessonId: string }>(),
);

export const getLessonFailure = createAction(
  '[School Lesson] Get lesson failure',
  props<{ error: AppExceptionModel }>(),
);

// Create Lesson Actions
export const create = createAction(
  '[School Lesson] Create',
  props<{ groupId: string; lesson: Lesson }>(),
);
export const createFailure = createAction(
  '[School Lesson] Create Failure',
  props<{ error: AppExceptionModel }>(),
);
export const createSuccess = createAction(
  '[School Lesson] Create Success',
  props<{ lesson: Lesson }>(),
);

// Update Lesson Actions
export const update = createAction(
  '[School Lesson] Update',
  props<{ groupId: string; lessonId: string; lesson: Lesson }>(),
);
export const updateFailure = createAction(
  '[School Lesson] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Lesson] Update Success',
  props<{ lesson: Lesson }>(),
);

export const updateNotesFailure = createAction(
  '[School Lesson] Update Notes Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateNotesSuccess = createAction(
  '[School Lesson] Update Notes Success',
  props<{ lesson: Lesson }>(),
);

// Delete Lesson Actions
export const deleteAction = createAction(
  '[School Lesson] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[School Lesson] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Lesson] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Lesson] Clear from store',
  props<{ id: string }>(),
);

export const loadLessonStats = createAction(
  '[School Grade] Load Lessons Stats',
  props<{ groupId: string }>(),
);

export const clear = createAction('[School Lesson] Clear Lessons');

export const clearByAcademicYear = createAction(
  '[School Lesson] Clear Lessons By Academic Year',
  props<{ groupId: string; academicYear: number }>(),
);
